"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES, VIDEO_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const highlightCardInputs = [
  {
    name: "backgroundType",
    type: "string",
    enum: ["image", "video"],
    defaultValue: "image",
  },
  {
    name: "imageUrl",
    friendlyName: "Background image",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    showIf: `options.get("backgroundType") === "image"`,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F035813b7aeb845139d31942675bcbb18",
  },
  {
    name: "videoFileReference",
    friendlyName: "Background video",
    type: "file",
    allowedFileTypes: VIDEO_FILE_TYPES,
    showIf: `options.get("backgroundType") === "video"`,
    defaultValue:
      "https://cdn.builder.io/o/assets%2F90293f7dc9704cb5935f357315020051%2F3f9ea760cbb44c8abb42cb0fc6a209b0?alt=media&token=58400621-6790-4f7a-aff0-ace900180fd4&apiKey=90293f7dc9704cb5935f357315020051",
  },
  {
    name: "alt",
    friendlyName: "Image alt text",
    type: "string",
  },
  {
    name: "imageSeoTitle",
    friendlyName: "Image SEO title",
    type: "string",
  },
  {
    name: "buttonText",
    type: "string",
    required: true,
    defaultValue: "Learn more",
  },
  {
    name: "description",
    type: "string",
    defaultValue: "Nunc varius nisl felis. Donec fermentum, lorem at scelerisque",
  },
  {
    name: "title",
    type: "string",
    defaultValue: "Highlight title",
    required: true,
  },
  {
    name: "linkUrl",
    type: "string",
    required: true,
    defaultValue: "/",
  },
  {
    name: "openIn",
    type: "enum",
    enum: ["sameTab", "newTab"],
    defaultValue: "sameTab",
  },
  {
    name: "trackingEvent",
    friendlyName: "Tracking event",
    type: "string",
    enum: [
      { label: "None", value: "" },
      { label: "CTA Click", value: "cta_click" },
      { label: "Free trial click", value: "free_trial_click" },
      { label: "Ploom club click", value: "ploom_club_click" },
      { label: "Consumer care click", value: "consumer_care_click" },
      { label: "Contact click", value: "contact_click" },
      { label: "Phone click", value: "phone_click" },
      { label: "Search", value: "search" },
      { label: "Follow", value: "follow" },
    ],
    defaultValue: "",
  },
  {
    name: "theme",
    type: "string",
    enum: ["light", "dark"],
    defaultValue: "dark",
    required: true,
  },
  {
    name: "leftBadgeText",
    type: "string",
    defaultValue: "New",
  },
  {
    name: "rightBadgeText",
    type: "string",
    defaultValue: "10%",
  },
] as const satisfies Inputs;

export const HighlightCardComponent: RegisteredComponent = {
  name: "HighlightCard",
  component: dynamic(async () =>
    withValidation(highlightCardInputs, (await import("./HighlightCard")).HighlightCard, "HighlightCard")
  ),
  inputs: highlightCardInputs,
};
